export interface UrlsModel {
    wifiLogoUrl: string;
    sasTACCUrl: string;
    viasatTACCUrl: string;
}

export class PnrFormDataModel {
    pnr: string;
    firstname: string;
    secondname: string;
    email: string;
    vouchercode: string;
    sastandc: boolean;
    viasattandc: boolean;    
    paxid: string;
}

export class CrewVoucherDataModel{
    firstName: string;
    lastName: string;
    email: any;
    voucherCode: any;
}
export interface CharterFormDataModel {
    email: string;
    firstname: string;
    secondname: string;
    vouchercode: string;
    sastandc: boolean;
}


export interface WifiActivateRequestModel {
    url: string;
    data: PnrRequestDataModel;
}

interface PnrRequestDataModel {
    flightId: string;
    passenger: PassengerRequestDataModel;
}

interface PassengerRequestDataModel {
    firstName?: string;
    lastName?: string;
    bookingReference?: string;
    sessionId?: string;
    id?: string;
    voucherCode?: string;
}

export interface GEtDeviceTypeRequestModel {
    url: string;
}
